import React from "react";

const ActiveFilterChips = ({ chips = [], onRemove, onClearAll }) => {
  if (!chips.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm" aria-live="polite">
      <span className="font-semibold text-gray-600">Active filters:</span>
      {chips.map((chip) => (
        <span
          key={chip.key}
          className="inline-flex items-center gap-1 rounded-full bg-[#E6F2F2] border border-[#7FBFC1] text-[#0B5557] pl-3 pr-2 py-1"
        >
          <span className="font-semibold">{chip.label}:</span>
          <span>{chip.value}</span>
          {onRemove && (
            <button
              type="button"
              onClick={() => onRemove(chip.key)}
              aria-label={`Remove ${chip.label} filter`}
              title={`Remove ${chip.label} filter`}
              className="ml-1 rounded-full w-5 h-5 leading-none text-[#0B5557] hover:bg-[#137E81] hover:text-white"
            >
              ×
            </button>
          )}
        </span>
      ))}
      {onClearAll && (
        <button
          type="button"
          onClick={onClearAll}
          className="text-xs font-semibold text-[#137E81] underline hover:text-[#0B5557]"
        >
          Clear all
        </button>
      )}
    </div>
  );
};

export default ActiveFilterChips;
